import React, { ReactNode } from "react";

import { Flex, SkeletonWrapper, Steps } from "components";

export type StepType = {
  title?: ReactNode;
  description?: ReactNode;
  status?: "wait" | "process" | "finish" | "error";
  disabled?: boolean;
  icon?: ReactNode;
};

export type StepsWidgetProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  steps: StepType[];
  currentStep: number;
  className?: string;
  direction?: "horizontal" | "vertical";
  labelPlacement?: "horizontal" | "vertical";
  children?: ReactNode;
  isLoading?: boolean;
};

export const StepsWidget = ({
  title,
  subtitle,
  description,
  steps,
  currentStep,
  className = "",
  direction,
  labelPlacement,
  children,
  isLoading,
}: StepsWidgetProps) => {
  const stepsClassName = direction === "horizontal" ? "margin-top-75 klim-steps klim-steps-horizontal" : "margin-top-75 klim-steps klim-steps-vertical";

  return (
    <>
      <Flex vertical gap={12} className={className}>
        <SkeletonWrapper className="skeleton-rectangular" height="1rem" width="25%" type="block" isLoading={isLoading}>
          {subtitle && <h6 className="steps-widget-subtitle">{subtitle}</h6>}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" height="2.5rem" width="45%" type="block" isLoading={isLoading}>
          {title && <h1>{title}</h1>}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" rows={3} width="90%" type="paragraph" isLoading={isLoading}>
          {description && <span className="paragraph-m margin-top-75 steps-widget-description">{description}</span>}
        </SkeletonWrapper>
        <SkeletonWrapper className="skeleton-rectangular" rows={6} width="40%" type="paragraph" isLoading={isLoading}>
          <Steps current={currentStep} items={steps} className={stepsClassName} direction={direction} labelPlacement={labelPlacement} />
        </SkeletonWrapper>
      </Flex>
      <SkeletonWrapper className="skeleton-rectangular" height="1.5rem" width="40%" type="block" isLoading={isLoading}>
        <Flex>{children}</Flex>
      </SkeletonWrapper>
    </>
  );
};

export default StepsWidget;
